<button
  type="button"
  class="detail-settings-trigger"
  [class.active]="open"
  (click)="toggle()"
  [attr.aria-expanded]="open"
  [attr.aria-label]="'detail_fields.settings' | translate"
>
  <ui-svg-icon [svgIcon]="triggerIcon" size="small"></ui-svg-icon>
</button>

<div class="detail-settings-backdrop" *ngIf="open" (click)="close()"></div>

<div class="detail-settings-drawer" *ngIf="open" (click)="$event.stopPropagation()">
  <div class="detail-settings-header">
    <span class="detail-settings-title">{{ 'detail_fields.settings' | translate }}</span>
    <button
      type="button"
      class="detail-settings-close"
      (click)="close()"
      [attr.aria-label]="'common.close' | translate"
    >
      <ui-svg-icon svgIcon="close" size="small"></ui-svg-icon>
    </button>
  </div>

  <p class="detail-settings-intro">{{ 'detail_fields.drag_to_reorder' | translate }}</p>

  <div class="detail-settings-group" *ngFor="let group of groups">
    <span class="detail-settings-group-title">{{ group.title | translate }}</span>

    <div
      cdkDropList
      class="detail-settings-list"
      (cdkDropListDropped)="onDrop(group, $event)"
    >
      <div
        class="detail-settings-row"
        *ngFor="let field of visibleOf(group); trackBy: trackByKey"
        cdkDrag
        [cdkDragDisabled]="!isHideable(field)"
      >
        <span class="detail-settings-handle" cdkDragHandle>
          <ui-svg-icon svgIcon="grip-vertical" size="small"></ui-svg-icon>
        </span>

        <span class="detail-settings-label">{{ field.label | translate }}</span>

        <button
          type="button"
          class="detail-settings-toggle"
          *ngIf="isHideable(field)"
          (click)="hide(group, field)"
          [attr.aria-label]="'table_columns.hide' | translate"
        >
          <ui-svg-icon svgIcon="eye-close" size="small"></ui-svg-icon>
        </button>
        <span class="detail-settings-pin" *ngIf="!isHideable(field)">
          <ui-svg-icon svgIcon="pin" size="small"></ui-svg-icon>
        </span>
      </div>
    </div>

    <div class="detail-settings-list detail-settings-list--hidden" *ngIf="hiddenOf(group).length">
      <div
        class="detail-settings-row detail-settings-row--hidden"
        *ngFor="let field of hiddenOf(group); trackBy: trackByKey"
      >
        <span class="detail-settings-label">{{ field.label | translate }}</span>
        <button
          type="button"
          class="detail-settings-toggle"
          (click)="show(group, field)"
          [attr.aria-label]="'table_columns.show' | translate"
        >
          <ui-svg-icon svgIcon="eye" size="small"></ui-svg-icon>
        </button>
      </div>
    </div>
  </div>
</div>
